// extracted by mini-css-extract-plugin
module.exports = {"tr":"Directory_tr__X4TE8","dTable":"Directory_dTable__nu76w"};